/**
 * Content carousel with extensive options to control behaviour and appearance
 * @requires https://github.com/nolimits4web/swiper
 */

import vendorMissing from './vendor-missing'
import onFragment, { within } from './on-fragment'

export default (() => {
  const options = (el) =>
    el.dataset.swiperOptions != undefined
      ? JSON.parse(el.dataset.swiperOptions)
      : {}

  // Swiper keeps its instance on the element (el.swiper): a slider that has
  // one is set up already - by an earlier run, or as another slider's
  // controlled slider
  /* eslint-disable no-undef */
  const built = (el) => el.swiper instanceof Swiper
  const create = (el, opts) => (built(el) ? el.swiper : new Swiper(el, opts))
  /* eslint-enable no-undef */

  const setup = (value) => {
    if (built(value)) return
    let opts = options(value)

    // Thumbnails
    if (opts.thumbnails) {
      let images = opts.thumbnails.images
      opts = Object.assign({}, opts, {
        pagination: {
          el: opts.thumbnails.el,
          clickable: true,
          bulletActiveClass: 'active',
          renderBullet: (index, className) => {
            return `<li class='swiper-thumbnail ${className}'>
              <img src='${images[index]}' alt='Thumbnail'>
            </li>`
          },
        },
      })
    }

    const swiper = create(value, opts)

    // Controlled slider
    if (opts.controlledSlider) {
      const controlledSlider = document.querySelector(opts.controlledSlider)
      if (controlledSlider) {
        swiper.controller.control = create(
          controlledSlider,
          options(controlledSlider)
        )
      }
    }

    // Binded content
    if (opts.bindedContent) {
      swiper.on('activeIndexChange', (e) => {
        const targetItem = document.querySelector(
          e.slides[e.activeIndex].dataset.swiperBinded
        )
        const previousItem = document.querySelector(
          e.slides[e.previousIndex].dataset.swiperBinded
        )

        previousItem.classList.remove('active')
        targetItem.classList.add('active')
      })
    }
  }

  // Carousel initialisation: the page, then every fragment htmx swaps in
  // (an expanded listing card shows the entry's slideshow)
  onFragment((root) => {
    const carousels = within(root, '.swiper')
    if (carousels.length === 0) return
    if (vendorMissing('carousel', { Swiper: typeof Swiper })) return
    carousels.forEach(setup)
  })
})()
